import Footer from '../ui/Footer';
import { Helmet } from 'react-helmet-async';
import Sidebar from '../ui/Sidebar';
import BottomNav from '../ui/BottomNav';
import { useEffect, useState } from 'react';
import { checkSession } from '@/utils/auth';
import Loading from '@/components/Loading';

// アプリログイン中の画面レイアウト
// ヘッダー、フッター、メニューを扱う
function PrivateLayout({ children }: { children: React.ReactNode }) {
    const [isCheckingSession, setIsCheckingSession] = useState(true);

    // メイン処理
    useEffect(() => {
        // セッションチェック
        const check = async () => {
            try {
                await checkSession();
            } catch (error) {
                // checkSession内でリダイレクト処理が行われるため、エラーハンドリングは不要
            } finally {
                setIsCheckingSession(false);
            }
        };
        check();
    }, []);

    // セッションチェック中はローディング画面を表示
    if (isCheckingSession) {
        return <Loading />;
    }

    return (
        <>
            <Helmet>
                {/* 検索エンジンのクローラーによるインデックスを禁止 */}
                <meta name="robots" content="noindex,nofollow" />
            </Helmet>

            {/* 全体 */}
            <div className="flex min-h-screen overflow-hidden overflow-x-hidden lg:mb-0 mb-20">
                {/* サイドバー（PCのみ表示） */}
                <div className="hidden lg:block">
                    <Sidebar />
                </div>
                {/* コンテンツ */}
                <div className="flex flex-col flex-1 lg:ml-48 pb-4 lg:pb-0">
                    {/* メインコンテンツ */}
                    {children}
                    {/* フッター */}
                    <Footer />
                </div>
                {/* ボトムナビゲーション（モバイルのみ表示） */}
                <div className="lg:hidden" style={{ boxShadow: '0 -4px 6px rgba(0,0,0,0.8)' }}>
                    <BottomNav />
                </div>
            </div>
        </>
    );
}

export default PrivateLayout;
